import Backbone from 'backbone'

const TypeModel = Backbone.Model.extend({
    defaults: {
        name: null,
    }
})

export default TypeModel
